import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Business logic
import { useDeleteTicket } from "../hooks/useTicketMutations";
import { useSelectedTicketsContext } from "../context/SelectedTicketsContext";

// Components
import { SelectedTicketsContext } from "../context/SelectedTicketsContext";
import ItemDeleteDialog from "../../../shared/components/ItemDeleteDialog";
import TicketsDataGrid from "./TicketsDataGrid";
import TicketsFiltersPanel from "./TicketFiltersPanel";
import TicketsToolbar from "./TicketsToolbar";

function TicketsContent() {
  const [isRemoverOpen, setIsRemoverOpen] = useState(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const { value: selectedTickets } = useSelectedTicketsContext();

  // Parameters
  const location = useLocation();
  const navigate = useNavigate();
  const [queryParameters, setQueryParameters] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Load saved query parameters from localStorage on mount
  useEffect(() => {
    if (isInitialLoad && (!location.search || location.search === "")) {
      try {
        const savedParams = localStorage.getItem("tickets_query_params");
        if (savedParams) {
          const parsedParams = JSON.parse(savedParams);
          const params = new URLSearchParams();
          Object.entries(parsedParams).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== "") {
              params.append(key, value);
            }
          });
          if (params.toString()) {
            navigate({ search: params.toString() }, { replace: true });
          }
        }
      } catch (error) {
        console.error("Failed to load saved query parameters:", error);
      }
      setIsInitialLoad(false);
    }
  }, [isInitialLoad, location.search, navigate]);

  // useEffects
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newQueryParams = {
      type: params.get("type") || null,
      status_id: params.get("status_id") || null,
      req_id: params.get("req_id") || null,
    };
    setQueryParameters(newQueryParams);

    // Save to localStorage whenever query parameters change
    const hasActiveParams = Object.values(newQueryParams).some((v) => v !== null && v !== undefined && v !== "");
    if (hasActiveParams) {
      localStorage.setItem("tickets_query_params", JSON.stringify(newQueryParams));
    } else {
      localStorage.removeItem("tickets_query_params");
    }
  }, [location.search]);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      <TicketsToolbar
        setIsRemoverOpen={setIsRemoverOpen}
        setIsFiltersOpen={setIsFiltersOpen}
        queryParameters={queryParameters}
      />
      <div style={{ position: "relative", display: "flex", flex: 1, overflow: "hidden", width: "100%" }}>
        <TicketsDataGrid data-testid="tickets-datagrid" />
        <ItemDeleteDialog
          isOpen={isRemoverOpen}
          setIsOpen={setIsRemoverOpen}
          useMutationHook={useDeleteTicket}
          id={selectedTickets?.[0]?.id}
          name={`${selectedTickets?.[0]?.type}-${selectedTickets?.[0]?.id}`}
          queryKey={["tickets"]}
        />
        <TicketsFiltersPanel
          isOpen={isFiltersOpen}
          setIsOpen={setIsFiltersOpen}
          queryParameters={queryParameters}
          setQueryParameters={setQueryParameters}
        />
      </div>
    </div>
  );
}

function Tickets() {
  return (
    <SelectedTicketsContext>
      <TicketsContent />
    </SelectedTicketsContext>
  );
}

export default Tickets;
